import GA4AnaliticsEventBus from '~/core/events/ga4-analitics'
import { useSelectorToQueryParam } from '../shared/useSelectorToQueryParam'

import { CheckBoxNode } from "~/core/ts/entity/CheckBoxNode"

export function useMultiPromoFilter(options: globalThis.Ref<Array<CheckBoxNode>>) {
  const multiPromoOptions = options

  const route = useRoute()

  const {
    optionSelected,
    pushQueryParam,
  } = useSelectorToQueryParam({
    label: 'promotions',
    defaultValue: ''
  })

  function onMultiPromoInput(data: Array<CheckBoxNode>) {
    multiPromoOptions.value = data

    const selectedIndices = multiPromoOptions.value
      .map((checkNode) => {
        if (checkNode.value) {
          return checkNode.id
        }

        return null
      })
      .filter((id) => !!id)

    pushQueryParam(selectedIndices.join(','))
    if (selectedIndices.length) {
      GA4AnaliticsEventBus.send('filter_by_promotion', {
        path: route.path,
        promotion_ids: selectedIndices,
      })
    }
  }

  function onPromoCategoryNodeClick() {
    onMultiPromoInput(multiPromoOptions.value)
  }

  const selectedPromos = computed(() => {
    if (!optionSelected.value.value) {
      return []
    }

    const ids = optionSelected.value.value.split(',')

    const selectedPromos = []
    for (const uuid of ids) {
      for (const category of multiPromoOptions.value) {
        if (category.id === uuid) {
          selectedPromos.push(category)
        }
      }
    }

    return selectedPromos
  })

  const selectedPromosIDs = computed(() => {
    if (!optionSelected.value.value) {
      return []
    }

    return optionSelected.value.value.split(',')
  })

  const firstLoad = ref(true)

  onMounted(() => {
    setTimeout(() => {
      // Se pillan los parámetros de la URL y se actualiza el 'multiPromoOptions'
      //   con las opciones que están activadas.
      // Esto hace falta para mantener el número de spas con cada promoTag en el filtro.
      //     Eg. Daypass (4)
      if (firstLoad.value) {
        firstLoad.value = false

        if (optionSelected.value.value) {
          const ids = optionSelected.value.value.split(',')

          multiPromoOptions.value = multiPromoOptions.value
            .map((option) => {
              if (ids.includes(option.id)) {
                option.value = true
              }

              return option
            })
            .sort((opA) => {
              if (opA.value) {
                return -1
              }

              return 0
            })
        }
      }
    }, 100)
  })

  return {
    selectedPromosIDs,
    selectedPromos,
    multiPromoOptions,
    onMultiPromoInput,
    onPromoCategoryNodeClick,
  }
}
